import { Type } from "class-transformer";
import { observable } from "mobx";
import "reflect-metadata";
import { EntityValidationRules } from "services/validationService";
import FuelTypeLimitationResponse from "entities/fuelTypeLimitationResponse";
import ChargePriceListItemResponse from "entities/chargePriceListItemResponse";
import ChargeValidityRequest from "entities/chargeValidityRequest";
import NotificationPreferences from "./notificationPreferences";

export const LicensePlateValidationRules: EntityValidationRules<ChargeOrderItem> = {
  licensePlate: {
    hasRequiredLength: { min: 1, max: 10 },
    isLicensePlate: true,
  },
};

export const LicensePlatesValidationRules: EntityValidationRules<ChargeOrderItem> = {
  licensePlates: {
    required: true,
    hasRequiredLength: {
      min: 1,
      max: 200,
    },
  },
};

export const LicensePlateConfirmationValidationRules: EntityValidationRules<ChargeOrderItem> = {
  _licensePlateConfirmation: {
    equalWith: { property: "licensePlate" as const },
    hasRequiredLength: { min: 1, max: 10 },
    isLicensePlate: true,
  },
};

export const EmailValidationRules: EntityValidationRules<NotificationPreferences> = {
  emailAddress: {
    isEmail: true,
  },
};

export const EmailConfirmationValidationRules: EntityValidationRules<NotificationPreferences> = {
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const EmailNotificationValidationRules: EntityValidationRules<NotificationPreferences> = {
  _emailAddressNotification: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const CountryIdValidationRules: EntityValidationRules<ChargeOrderItem> = {
  countryId: { required: "requiredCountryId" },
};

export const FuelTypeValidationRules: EntityValidationRules<ChargeOrderItem> = {
  fuelTypeId: { required: true },
};

export const ChargeTypeIdValidationRules: EntityValidationRules<ChargeOrderItem> = {
  chargeTypeId: {
    required: true,
  },
};

export default class ChargeOrderItem {
  id? = Math.random().toString();

  authCode: string;

  @observable
  licensePlate?: string;

  @observable
  licensePlates: string[] = [];

  @observable
  countryId?: string;

  @observable
  priceListItemId: string;

  @observable
  validity: ChargeValidityRequest = new ChargeValidityRequest();

  @observable
  _licensePlateConfirmation?: string;

  @observable
  _chargeTypeId?: string;

  @observable
  _fuelTypeId?: string;

  @observable
  _singleChargeType = false;

  @observable
  _priceListItems: ChargePriceListItemResponse[] = [];

  @observable
  _visible = true;

  @observable
  _duplicities = 0;

  @observable
  @Type(() => FuelTypeLimitationResponse)
  _fuelTypeLimitation?: FuelTypeLimitationResponse;

  /* multiEshop  */

  @Type(() => Date)
  @observable
  validSince?: Date;

  @observable
  chargeTypeId?: string;

  @observable
  fuelTypeId?: string;

  @Type(() => NotificationPreferences)
  @observable
  notificationPreferences: NotificationPreferences;

  @observable
  _fuelTypeLimitationOrder?: string[];

  @Type(() => Date)
  @observable
  _validUntil?: Date;

  @Type(() => Date)
  @observable
  _validUntilOverlap?: Date;

  @observable
  _hasImmediateValidity?: boolean;

  @Type(() => Date)
  @observable
  _validSinceDaysBefore?: Date;

  @observable
  _showCountryWarning: boolean;

  @observable
  _allowedDelete = false;

  @observable
  _isModified = false;
}

export const ChargeOrderItemValidationRules: EntityValidationRules<ChargeOrderItem> = {
  ...LicensePlateValidationRules,
  ...LicensePlateConfirmationValidationRules,
  ...CountryIdValidationRules,
};

export const ChargeOrderItemBatchValidationRules: EntityValidationRules<ChargeOrderItem> = {
  ...LicensePlatesValidationRules,
  ...CountryIdValidationRules,
  ...FuelTypeValidationRules,
  ...ChargeTypeIdValidationRules,
};
